import React, { Component } from "react";
import ReactSVG from "react-svg";
import { string, bool, objectOf, any } from "prop-types";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import { getDevicePlatform } from "util/device";

import { resizableRoute } from "pages/_components/Resizable";

class Image extends Component {
    static propTypes = {
        src: string.isRequired,
        altText: string,
        className: string,
        wrapperClassName: string,
        iconRight: bool,
        isMobileNative: bool,
        height: string,
        width: string,
        styles: objectOf(any),
        location: string,
    };

    static defaultProps = {
        altText: "",
        className: "svg-image",
        wrapperClassName: "svg-wrapper",
        iconRight: false,
        isMobileNative: false,
        height: "",
        width: "",
        styles: {},
        location: "",
    };

    render() {
        const { isMobileNative, src, styles, location } = this.props;

        const path = src.replace("images/", "").replace(/^\//, "");
        let fullPath;
        try {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            fullPath = require(`styles/images/${path}`);
        } catch {
            // eslint-disable-next-line global-require
            fullPath = require(`styles/images/figma/icon/info.svg`);
        }

        fullPath = fullPath.replace(/^\//, "");

        if (!isMobileNative) {
            const pathDepth = location.pathname.split("/").length - 1;
            const pathPrefix = Array(pathDepth).join("../");
            fullPath = pathPrefix + fullPath;
        }

        const { altText, iconRight, className, wrapperClassName, height, width } = this.props;

        if (isMobileNative && getDevicePlatform() === "iOS") {
            return (
                <div className="svg-wrapper">
                    <div>
                        <img
                            alt={altText}
                            src={fullPath}
                            style={styles}
                            className={className}
                            height={height}
                            width={width}
                        />
                    </div>
                </div>
            );
        }

        return (
            <ReactSVG
                alt={altText}
                path={fullPath}
                className={className}
                wrapperClassName={classNames(wrapperClassName, {
                    "align-right": iconRight,
                })}
                style={styles}
            />
        );
    }
}

export default resizableRoute(withRouter(Image));
